import React, { useCallback, useMemo } from 'react';
import { DietaryIconImg } from 'src/shared/utils/IconUtils';
import styled from 'styled-components';
import { DietaryTags } from 'web-common/src/shared/Enums';
import { Spacing } from 'web-common/src/shared/styles';
import { FilterSelector, Option } from '../FilterSelector';

interface IProps {
  dietaryOptions: DietaryTags[];
  activeDietaryTags: DietaryTags[];
  onSubmit: (values: { dietaryTags?: DietaryTags[] }) => void;
}

const DietaryTagOption = styled.div`
  display: flex;
  align-items: center;
`;
const DietaryTagText = styled.span`
  margin-left: ${Spacing.HALF};
`;

export const DietaryFilterSelector: React.FC<IProps> = ({ dietaryOptions, activeDietaryTags, onSubmit }) => {
  const filterOptions = useMemo(
    () =>
      dietaryOptions.map(
        (dietaryTag): Option<DietaryTags> => ({
          value: dietaryTag,
          display: (
            <DietaryTagOption>
              <DietaryIconImg dietaryTag={dietaryTag} />
              <DietaryTagText>{dietaryTag}</DietaryTagText>
            </DietaryTagOption>
          ),
        })
      ),
    [dietaryOptions]
  );

  const handleSubmit = useCallback(
    (values?: DietaryTags[]) => {
      onSubmit(values ? { dietaryTags: values } : {});
    },
    [onSubmit]
  );

  return (
    <FilterSelector
      filterKey='dietary'
      filterTitle='Dietary'
      filterOptions={filterOptions}
      selectedValues={activeDietaryTags}
      singleFilter={true}
      onSubmit={handleSubmit}
    />
  );
};
